document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){toggle.addEventListener('click',function(){var open=menu.classList.toggle('is-open');toggle.setAttribute('aria-expanded',open?'true':'false');toggle.setAttribute('aria-label',open?'Close menu':'Open menu');});}
});
(function () {
  function initialise(root) {
    root.querySelectorAll('[data-nexilia-product]').forEach(function (section) {
      if (section.dataset.pickerReady) return;
      var data = section.querySelector('[data-variant-data]');
      var picker = section.querySelector('[data-option-picker]');
      if (!data || !picker) return;
      var variants = JSON.parse(data.textContent);
      var fields = Array.from(picker.querySelectorAll('fieldset'));
      var idInput = section.querySelector('[data-variant-id]');
      var price = section.querySelector('[data-variant-price]');
      var button = section.querySelector('[data-add-to-bag]');
      var status = section.querySelector('[data-variant-status]');
      var form = idInput.closest('form');
      function update(changeUrl) {
        var selected = fields.map(function (field) {
          var checked = field.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        var variant = variants.find(function (item) {
          return item.options.every(function (value, index) { return value === selected[index]; });
        });
        idInput.value = variant ? String(variant.id) : '';
        idInput.disabled = !variant || !variant.available;
        button.disabled = !variant || !variant.available;
        button.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to bag' : 'Sold out';
        price.innerHTML = variant ? variant.price : 'Unavailable';
        status.textContent = !variant ? 'This combination is unavailable. Please choose another option.' : !variant.available ? 'This combination is sold out.' : '';
        if (changeUrl) {
          var url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
        }
      }
      picker.addEventListener('change', function () { update(true); });
      form.addEventListener('submit', function (event) {
        if (button.disabled || idInput.disabled || !idInput.value) event.preventDefault();
      });
      update(false);
      section.querySelector('[data-variant-fallback]').hidden = true;
      picker.hidden = false;
      section.dataset.pickerReady = 'true';
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
